import { bikeCategoriesArray } from "constants/index"

export const STYLE_FILTER_SHORT_NAME = "category"
export const styleDefault = []

const sN = STYLE_FILTER_SHORT_NAME
const sD = styleDefault

export const STYLE_FILTER_CONFIG = {
  short_name: sN,
  default_values: sD,
  is_default: value => testStyleDefault(value), //right before clean up
  format_to_api: value => formatStyleForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: value => formatStyleFromURL(value) //
}

export const formatStyleFromURL = value => {
  let cleanValue = null
  if (value) {
    cleanValue = value
    if (!(value instanceof Array)) {
      //if it's not an array we cast it to an array
      cleanValue = [value.toString()]
    }
    //ok so we have have an array of things, but is it part of our brandlist?
    for (let i = 0; i < cleanValue.length; i++) {
      if (!bikeCategoriesArray.includes(cleanValue[i])) {
        cleanValue.splice(i, 1)
      }
    }
    //after we loop, let's check that we even still an array though.
    if (cleanValue.length === 0) {
      cleanValue = null
    }
  }
  return cleanValue
}

export const testStyleDefault = value => {
  if (value) {
    if (value?.length > 0) {
      return false
    } else {
      return true
    }
  } else {
    return true
  }
}

//api
export const formatStyleForAPI = value => {
  if (value) {
    return { categories: value.join() }
  } else {
    return {}
  }
}
